import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/home_header.jpg";
import SEO from "../designSystem/SEO";
import LightOutlinedButton from "../designSystem/buttons/LightOutlinedButton";
import LineLinkButton from "../designSystem/buttons/LineLinkButton";
import FinancialAdviceImage1 from "../../assets/images/financial_image_001.png";
import FinancialAdviceImage2 from "../../assets/images/financial_image_002.jpg";
import FAQ from "../designSystem/FAQ";
import { scrollToContact } from "../utils/navigation";

const PersonalFinancialAdvicePage = () => {
  return (
    <div>
      <SEO
        title="Personal Financial Advice"
        description="Bring your mortgages, pensions, investments and retirement plans into focus with personal financial advice from Monk Financial Planning."
        path="/financial-advice"
      />
      <Hero
        //         title={`Financial Clarity
        // Direction & Confidence`}
        //         subtitle="Wealth Management Solutions"
        showOverlay={true}
        // backgroundImage={HeroBackground}
        titleAlign="center"
        subtitleAlign="center"
        pageTitle="Financial Advice"
        title="Personal financial advice"
        subtitle="Good financial planning starts with understanding where you are now and where you want to be in the future. We can help you look at your financial position across areas such as mortgages, pensions, investments and retirement planning. Whether you’re planning for a major life event or simply want to understand your options, we can provide clear, personal advice based on your circumstances."
        showButton={true}
        textAlign="center"
      ></Hero>

      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-reverse row-ratio-47-63">
          <div className="column gap-l">
            <LineLinkButton children="Financial Advice" />
            <h4 className="text-gray-3 uppercase">
              Bring Your Finances Into Focus
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Your financial circumstances and priorities can change
                throughout your life, which is why it can be helpful to
                regularly review your plans. We can help you understand your
                current financial position and consider the options available to
                you across areas including mortgages, pensions, investments and
                retirement planning.
              </div>
              <div className="content text-gray-3">
                Whether you’re looking to make a specific financial decision or
                want to take a broader look at your plans, we can help you
                understand how different areas of your finances could work
                together. Our aim is to provide clear, personal advice that
                helps you make informed decisions about your future.
              </div>
            </div>
          </div>
          <img
            src={FinancialAdviceImage1}
            alt="Financial adviser discussing a client's financial goals"
            className="image-cover"
          />
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container column align-center gap-l py-xxl px-xxxl">
          <LineLinkButton children="financial advice" />
          <h4 className="uppercase text-primary-1">How we can help</h4>
          <FAQ
            items={[
              {
                question: "Buying Your First Home",
                answer:
                  "Buying your first home is a major financial decision and there are several areas to consider. We can help you understand your mortgage options and how this fits into your wider financial position and future plans.",
              },
              {
                question: "Moving or Remortgaging",
                answer:
                  "Your mortgage needs can change when you move home or your existing deal comes to an end. We can review your circumstances and help you understand the options available, whether you’re moving house or considering a new mortgage.",
              },
              {
                question: "Building Your Pension",
                answer:
                  "Planning for retirement can start at any stage of your working life. We can help you understand your pension arrangements, contributions and investments, and consider how they could support your longer-term financial goals.",
              },
              {
                question: "Planning Your Future",
                answer:
                  "Your financial plans should reflect what matters to you and the future you want to build. We can help you review your investments, retirement plans and wider finances to create a clearer picture of your options.",
              },
            ]}
          />
        </div>
      </div>
      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-ratio-47-63">
          <img
            src={FinancialAdviceImage2}
            alt="Client reviewing a personal financial plan"
            className="image-cover"
          />{" "}
          <div className="column gap-l">
            <LineLinkButton children="Financial Planning" />
            <h4 className="text-gray-3 uppercase">
              Looking at the Bigger Picture
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Your financial priorities can change throughout your life, from
                buying your first home and moving house to building your pension
                and approaching retirement. Taking the time to review your
                financial position can help you understand where you are now and
                what you may need to consider next.
              </div>
              <div className="content text-gray-3">
                We can help you look at your finances alongside your wider goals
                and circumstances, whether you’re planning for your family’s
                future, reviewing existing investments or preparing for
                retirement. By considering the bigger picture, we can help you
                make informed decisions and plan with greater confidence.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton onClick={scrollToContact} children="Contact Us" />
          <h4 className=" text-gray-3 uppercase">Ready to talk?</h4>
          <div className="content text-gray-3">
            We can help you consider how pensions and investments could work
            together as part of your financial plan.
          </div>
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        </div>
      </div>
    </div>
  );
};

export default PersonalFinancialAdvicePage;
